import React, { useMemo } from "react";
import PatientAppLayout from "../../components/PatientAppLayout/PatientAppLayout";
import { usePlatformSettingsPublic } from "../../hooks/usePlatformSettingsPublic";
import packageJson from "../../../package.json";
import "./PatientProfileSubpages.scss";

export default function PatientProfileAppVersionPage() {
  const { data, loading, error } = usePlatformSettingsPublic();

  const rows = useMemo(() => {
    const v = data?.versions || {};
    const lv = data?.legalVersions || {};
    return [
      { k: "Patient app (this build)", val: String(packageJson?.version || "—") },
      { k: "Patient web (platform)", val: String(v.patientWeb || "—").trim() || "—" },
      { k: "API", val: String(v.api || "—").trim() || "—" },
      { k: "Terms version", val: String(lv.terms || "—").trim() || "—" },
      { k: "Privacy version", val: String(lv.privacy || "—").trim() || "—" },
    ];
  }, [data]);

  return (
    <PatientAppLayout activeNav="profile">
      <div className="patient-profile-sub patient-profile-sub--version">
        <div className="patient-profile-sub__card">
          <h1 className="patient-profile-sub__h1">App version</h1>
          <p className="patient-profile-sub__lede">
            Build and platform identifiers. Legal document versions reflect what the care team has published.
          </p>

          {loading ? (
            <p className="patient-profile-sub__loading" role="status">
              Loading…
            </p>
          ) : null}
          {error ? (
            <p className="patient-profile-sub__error" role="alert">
              {error}
            </p>
          ) : null}

          <dl className="patient-profile-sub__kv">
            {rows.map(({ k, val }) => (
              <div key={k} className="patient-profile-sub__kvRow">
                <dt>{k}</dt>
                <dd>{val}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </PatientAppLayout>
  );
}
